<template>
  <div class="mx-auto">
    <h2 class="text-2xl text-primary font-bold mb-4 text-center">Sıkça Sorulan Sorular</h2>
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
      <div v-for="item in faqs" :key="item.id" class="py-3">
        <button
          @click="toggleFaq(item.id)"
          class="w-full text-left flex justify-between items-center py-2 px-4 bg-gray-100 hover:bg-gray-200 rounded-lg"
        >
          <span class="text-lg font-medium">{{ item.question }}</span>
          <span class="text-xl">{{ item.isOpen ? '−' : '+' }}</span>
        </button>
        <div v-if="item.isOpen" class="p-4 text-gray-600">
          {{ item.answer }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive } from 'vue';
import { useRoute } from 'vue-router';

export default defineComponent({
  name: 'FaqComponent',
  setup() {
    const route = useRoute();

    const faqs = reactive([
      {
        id: 1,
        question: "Bloqin nedir?",
        answer: "Bloqin, gerçek dünya varlıklarını tokenize ederek yatırımcılara blokzincir tabanlı, likit ve erişilebilir gayrimenkul yatırımı sunan bir platformdur.",
        isOpen: false
      },
      {
        id: 2,
        question: "Gayrimenkul tokenizasyonu nedir?",
        answer: "Gayrimenkuller gibi varlıklar tokenize edildiğinde, her bir token mülkün kısmi sahipliğini temsil eder ve yatırımcıların gayrimenkulün daha küçük bölümlerini alıp satmasına olanak tanır.",
        isOpen: false
      },
      {
        id: 3,
        question: "Bloqin’de nasıl yatırım yapabilirim?",
        answer: "Platforma üye olarak, tokenize edilmiş gayrimenkul projelerini inceleyebilir ve bütçenize uygun token satın alarak yatırım yapabilirsiniz.",
        isOpen: false
      },
      {
        id: 4,
        question: "Bloqin yatırımcılarına hangi avantajları sunuyor?",
        answer: "Bloqin, 7/24 likidite, aracıları ortadan kaldırarak daha fazla kazanç ve sınırları aşan kolay yatırım imkanı sunar.",
        isOpen: false
      },
      {
        id: 5,
        question: "Yatırımlarımı ne zaman satabilirim?",
        answer: "Tokenlerinizi vade sonunda veya belirlenen likidite pencerelerinde satışa sunabilir, kazancınızı değerlendirebilirsiniz.",
        isOpen: false
      },
      {
        id: 6,
        question: "Bloqin güvenli mi?",
        answer: "Evet, Bloqin blokzincir teknolojisiyle çalışır ve yatırımcıların varlıklarını güvence altına almak için akıllı sözleşmeler kullanır.",
        isOpen: false
      },
      {
        id: 7,
        question: "Bloqin ile hangi tür gayrimenkullere yatırım yapabilirim?",
        answer: "Bloqin, ticari, konut, turizm ve diğer yüksek getiri potansiyeline sahip gayrimenkul varlıklarını tokenize ederek yatırımcılara sunar.",
        isOpen: false
      },
      {
        id: 8,
        question: "Bloqin platformuna nasıl katılabilirim?",
        answer: "Bloqin’e üye olarak hesap oluşturabilir, kimlik doğrulama sürecini tamamladıktan sonra yatırım yapmaya başlayabilirsiniz.",
        isOpen: false
      }
    ]);

    const toggleFaq = (id: number) => {
      faqs.forEach((faq) => {
        if (faq.id === id) {
          faq.isOpen = !faq.isOpen;
        } else {
          faq.isOpen = false;
        }
      });
    };
    return { toggleFaq, faqs };
  }
});
</script>

<style scoped>
.faq-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

button {
  transition: background 0.3s ease-in-out;
}
</style>